
  import noneRuntime$_8oRK3A5BiUcieayGNGz1to2gNObexob3qxu7YRbdmO4 from '/usr/src/app/image-providers/passthrough.provider.ts'
import assetsRuntime$_1jo06aQQ6YaBHHV89pqwLBhsK1Do13d_45T_45t2QpRscKw from '/usr/src/app/image-providers/assets.provider.ts'
import mediahubRuntime$rYVxmmYTO8GPTsj66_wNhux6CRRa6smwU8s6MF6kkUQ from '/usr/src/app/image-providers/mediahub.provider.ts'
import kenticoRuntime$MOpb_45bwdp86UcWEOrFQY39PVCW9_45U3JyTx8d1mBagWQ from '/usr/src/app/image-providers/kentico.provider.ts'
import shpfyRuntime$ifa7Iaw2SGumQjxvmYalDlER2GZ_RiFqC_45Srk5HQ28k from '/usr/src/app/image-providers/shopify.provider.ts'
import ipxRuntime$_79E8XLHEzUmd6kXE8nIXQMZ1jKKpwMVMuRLrBod8Mmk from '/usr/src/app/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.2_ioredis@5.3.2_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1264,
    "2xl": 1440,
    "xs": 300
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "jpg",
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['none']: { setup: noneRuntime$_8oRK3A5BiUcieayGNGz1to2gNObexob3qxu7YRbdmO4, defaults: undefined },
  ['assets']: { setup: assetsRuntime$_1jo06aQQ6YaBHHV89pqwLBhsK1Do13d_45T_45t2QpRscKw, defaults: {} },
  ['mediahub']: { setup: mediahubRuntime$rYVxmmYTO8GPTsj66_wNhux6CRRa6smwU8s6MF6kkUQ, defaults: {} },
  ['kentico']: { setup: kenticoRuntime$MOpb_45bwdp86UcWEOrFQY39PVCW9_45U3JyTx8d1mBagWQ, defaults: {} },
  ['shpfy']: { setup: shpfyRuntime$ifa7Iaw2SGumQjxvmYalDlER2GZ_RiFqC_45Srk5HQ28k, defaults: {} },
  ['ipx']: { setup: ipxRuntime$_79E8XLHEzUmd6kXE8nIXQMZ1jKKpwMVMuRLrBod8Mmk, defaults: {} }
    }
  }
